/* eslint-disable prettier/prettier */
import { AccordionSummary, Box, Stack, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const TimerToggle = () => {
  const { t } = useTranslation();
  const [isTimerClock, setTimerClock] = useState(localStorage.getItem('timerClock') === 'true');

  const ToggleTimer = () => {
    if (isTimerClock) {
      localStorage.setItem('timerClock', 'false');
      setTimerClock(false);
    } else {
      localStorage.setItem('timerClock', 'true');
      setTimerClock(true);
    }

    window.dispatchEvent(new Event('storage'));
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Stack
          justifyContent={'space-between'}
          direction={'row'}
          width={'100%'}
          alignItems={'center'}
          onClick={(e) => {
            e.stopPropagation();
            ToggleTimer();
          }}
        >
          <Typography variant="h6" color={'primary'}>
            {t('Show timer in clock view')}
          </Typography>
          <Switch checked={isTimerClock} inputProps={{ 'aria-label': 'Toggle timer' }} />
        </Stack>
      </Box>
    </>
  );
};

export default TimerToggle;
